import React, { useEffect } from "react";
import PropTypes from "prop-types";
import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import { useDownloadURL } from "react-firebase-hooks/storage";
import CircularProgress from "@material-ui/core/CircularProgress";

// Renders an organization's report logo from storage at
// `{organizationId}/reportLogo.png`. Most organizations have no logo, so a
// missing file (404) is a normal state and renders `placeholder` rather than an
// error. Remount with a changing `key` to pick up a freshly uploaded logo.
function OrganizationLogo(props) {
  const { organizationId, width, height, placeholder, onLoadStateChange } =
    props;

  const ref = firebase.storage().ref(`${organizationId}/reportLogo.png`);
  const [downloadUrl, loading, error] = useDownloadURL(ref);

  const hasLogo = !loading && !error && !!downloadUrl;

  useEffect(() => {
    if (loading) return;
    onLoadStateChange?.(hasLogo);
  }, [loading, hasLogo]);

  if (loading) {
    return <CircularProgress size={Math.min(width, height, 24)} />;
  }

  if (error || !downloadUrl) {
    return placeholder ?? null;
  }

  return (
    <img
      src={downloadUrl}
      alt="Organization logo"
      style={{ maxWidth: width, maxHeight: height, objectFit: "contain" }}
    />
  );
}

OrganizationLogo.propTypes = {
  organizationId: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  placeholder: PropTypes.node,
  onLoadStateChange: PropTypes.func,
};

export default OrganizationLogo;
